import {tx} from '../lib/page-text';
import { useEffect } from "react";
import { useBlocker } from "react-router-dom";
import { unlocalizedPath } from '../lib/locale-path';

const active = new Set<symbol>();
export function confirmBroadcastSignOut() {
  return (
    !active.size ||
    window.confirm(
      tx("Sign out and disconnect this browser broadcast? Stay signed in to keep broadcasting."),
    )
  );
}
/** Search-only tool navigation preserves the publisher; leaving its page does not. */
export function useBroadcastNavigation(publishing: boolean) {
  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      publishing && unlocalizedPath(currentLocation.pathname) !== unlocalizedPath(nextLocation.pathname),
  );
  useEffect(() => {
    if (blocker.state === "blocked") {
      if (
        window.confirm(
          tx("Leave this page and disconnect your broadcast? Stay here to keep broadcasting."),
        )
      )
        blocker.proceed();
      else blocker.reset();
    }
  }, [blocker]);
  useEffect(() => {
    if (!publishing) return;
    const token = Symbol();
    active.add(token);
    const unload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = "";
    };
    window.addEventListener("beforeunload", unload);
    return () => {
      active.delete(token);
      window.removeEventListener("beforeunload", unload);
    };
  }, [publishing]);
}
